import i18n from '@/plugins/i18n';
const homeDashboard = {
  home: [
    {
      chartType: 'ChartSlow',
      entityType: 'Service',
      height: '300',
      independentSelector: false,
      metricName: 'service_total_call',
      metricType: 'REGULAR_VALUE',
      parentService: false,
      queryMetricType: 'sortMetrics',
      title: i18n.global.t('services-load-cpm-calls-per-minute'),
      unit: i18n.global.t('cpm-calls-per-minute'),
      width: 3,
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      chartType: 'ChartSlow',
      entityType: 'Service',
      height: '300',
      independentSelector: false,
      metricName: 'service_resp_time',
      metricType: 'REGULAR_VALUE',
      parentService: false,
      queryMetricType: 'sortMetrics',
      title: i18n.global.t('slow-services-ms'),
      unit: 'ms',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      aggregation: '/',
      aggregationNum: '10000',
      chartType: 'ChartSlow',
      entityType: 'Service',
      height: '300',
      independentSelector: false,
      metricName: 'service_apdex',
      metricType: 'REGULAR_VALUE',
      parentService: false,
      queryMetricType: 'sortMetrics',
      sortOrder: 'ASC',
      title: i18n.global.t('un-health-services-apdex'),
      width: 3,
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'apdex',
      },
    },

    {
      chartType: 'ChartSlow',
      entityType: 'Endpoint',
      height: '300',
      independentSelector: false,
      metricName: 'endpoint_avg',
      metricType: 'REGULAR_VALUE',
      parentService: false,
      queryMetricType: 'sortMetrics',
      title: i18n.global.t('slow-endpoints-ms'),
      unit: 'ms',
      width: 3,
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      chartType: 'ChartLine',
      entityType: 'All',
      height: '280',
      independentSelector: false,
      labelsIndex: '0, 1, 2, 3, 4',
      metricLabels: 'P50, P75, P90, P95, P99',
      metricName: 'all_percentile',
      metricType: 'LABELED_VALUE',
      queryMetricType: 'readLabeledMetricsValues',
      title: i18n.global.t('global-response-latency-percentile-in-ms'),
      unit: i18n.global.t('percentile-in-ms'),
      width: '6',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      chartType: 'ChartHeatmap',
      entityType: 'All',
      height: '280',
      independentSelector: false,
      metricName: 'all_heatmap',
      metricType: 'HEATMAP',
      queryMetricType: 'readHeatMap',
      title: i18n.global.t('global-heatmap-ms'),
      unit: 'ms',
      width: '6',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
};
export default homeDashboard;
